/* tslint:disable */
/* eslint-disable */

import React, { CSSProperties, SVGAttributes, FunctionComponent } from 'react';
import { getIconColor } from './helper';

interface Props extends Omit<SVGAttributes<SVGElement>, 'color'> {
  size?: number;
  color?: string | string[];
}

const DEFAULT_STYLE: CSSProperties = {
  display: 'block',
};

const IconZhifubao: FunctionComponent<Props> = ({ size, color, style: _style, ...rest }) => {
  const style = _style ? { ...DEFAULT_STYLE, ..._style } : DEFAULT_STYLE;

  return (
    <svg viewBox="0 0 1024 1024" width={size + 'px'} height={size + 'px'} style={style} {...rest}>
      <path
        d="M860.106243 0C950.212612 0 1023.936004 73.91538 1023.936004 164.149741v531.486782s-32.765952-4.15974-180.212737-53.372664c-40.95744-14.335104-96.249984-34.87782-157.686144-57.468409 36.861696-63.580026 65.531904-137.463409 86.010624-215.410537h-202.739329V297.549403h247.792513V256.495969h-247.792513V135.415537h-100.345728c-18.430848 0-18.430848 18.462846-18.430848 18.462846V258.543841H200.691457v41.053434h249.840385v69.75564H243.696769v41.021437H645.079683c-14.335104 51.324792-34.813824 98.521842-57.340417 141.623148-129.015937-43.133304-268.271233-78.011124-356.329729-55.420536-55.292544 14.367102-92.15424 39.005562-112.632961 63.612024-96.249984 116.95269-26.622336 295.469533 176.116993 295.469533 120.824448 0 237.553153-67.707768 327.659521-178.516842C757.712643 742.801575 1023.936004 853.642647 1023.936004 853.642647v6.143616c0 90.23436-73.723392 164.149741-163.829761 164.149741H163.829761C73.723392 1023.936004 0 950.08462 0 859.786263V164.149741C0 73.91538 73.723392 0 163.829761 0h696.276482zM268.111243 553.085432c93.050184-10.367352 180.052747 26.974314 283.246297 78.87507-74.87532 95.482032-165.941629 155.702269-256.943941 155.702269-157.814137 0-204.371227-126.648084-125.464158-197.203675 26.302356-22.846572 72.827448-35.293794 99.161802-37.373664z"
        fill={getIconColor(color, 0, '#00A0EA')}
      />
    </svg>
  );
};

IconZhifubao.defaultProps = {
  size: 18,
};

export default IconZhifubao;
